var _defs, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpotEngineLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1240 300",
    width: 1240,
    height: 300,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "seg",
    x1: 24,
    y1: 40,
    x2: 244,
    y2: 260,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5F6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC371"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 40,
    width: 220,
    height: 220,
    rx: 56,
    fill: "url(#seg)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 150,
    r: 64,
    stroke: "#0A0A12",
    strokeWidth: 24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 150,
    r: 30,
    fill: "#0A0A12"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 150,
    r: 13,
    fill: "url(#seg)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(295.0,192) scale(0.150000,-0.150000)",
    d: "M42 210H224Q228 171 251.0 150.5Q274 130 311 130Q349 130 371.0 147.5Q393 165 393 196Q393 222 375.5 239.0Q358 256 332.5 267.0Q307 278 260 292Q192 313 149.0 334.0Q106 355 75.0 396.0Q44 437 44 503Q44 601 115.0 656.5Q186 712 300 712Q416 712 487.0 656.5Q558 601 563 502H378Q376 536 353.0 555.5Q330 575 294 575Q263 575 244.0 558.5Q225 542 225 511Q225 477 257.0 458.0Q289 439 357 417Q425 394 467.5 373.0Q510 352 541.0 312.0Q572 272 572 209Q572 149 541.5 100.0Q511 51 453.0 22.0Q395 -7 316 -7Q239 -7 178.0 18.0Q117 43 80.5 92.0Q44 141 42 210Z",
    fill: "#0A0A12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(387.2,192) scale(0.150000,-0.150000)",
    d: "M405 566Q474 566 530.0 531.0Q586 496 618.5 431.0Q651 366 651 280Q651 194 618.5 128.5Q586 63 530.0 27.5Q474 -8 405 -8Q347 -8 302.5 16.0Q258 40 233 78V-266H62V558H233V479Q258 518 302.0 542.0Q346 566 405 566ZM354 417Q303 417 267.5 380.0Q232 343 232 279Q232 215 267.5 178.0Q303 141 354 141Q405 141 441.0 178.5Q477 216 477 280Q477 344 441.5 380.5Q406 417 354 417Z",
    fill: "#0A0A12"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(489.1,192) scale(0.150000,-0.150000)",
    d: "M28 279Q28 365 66.0 430.5Q104 496 170.0 531.0Q236 566 318 566Q400 566 466.0 531.0Q532 496 570.0 430.5Q608 365 608 279Q608 193 569.5 127.5Q531 62 464.5 27.0Q398 -8 316 -8Q234 -8 168.5 27.0Q103 62 65.5 127.0Q28 192 28 279ZM434 279Q434 346 400.5 382.0Q367 418 318 418Q268 418 235.0 382.5Q202 347 202 279Q202 212 234.5 176.0Q267 140 316 140Q365 140 399.5 176.0Q434 212 434 279Z",
    fill: "#0A0A12"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(584.6,192) scale(0.150000,-0.150000)",
    d: "M373 145V0H286Q193 0 141.0 45.5Q89 91 89 194V416H21V558H89V694H260V558H372V416H260V192Q260 167 272.0 156.0Q284 145 312 145Z",
    fill: "#0A0A12"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(645.5,192) scale(0.150000,-0.150000)",
    d: "M40 84Q40 124 68.5 151.0Q97 178 142 178Q186 178 214.5 151.0Q243 124 243 84Q243 45 214.5 18.5Q186 -8 142 -8Q97 -8 68.5 18.5Q40 45 40 84Z",
    fill: "#FF5F6D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(687.8,192) scale(0.150000,-0.150000)",
    d: "M233 565V423H462V291H233V137H492V0H62V702H492V565Z",
    fill: "#0A0A12"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(769.0,192) scale(0.150000,-0.150000)",
    d: "M617 326V0H447V303Q447 359 418.0 390.0Q389 421 340 421Q291 421 262.0 390.0Q233 359 233 303V0H62V558H233V484Q259 521 303.0 542.5Q347 564 402 564Q500 564 558.5 500.5Q617 437 617 326Z",
    fill: "#0A0A12"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(870.1,192) scale(0.150000,-0.150000)",
    d: "M446 479V558H617V1Q617 -76 586.5 -138.5Q556 -201 493.5 -238.0Q431 -275 338 -275Q214 -275 137.0 -216.5Q60 -158 49 -58H218Q226 -90 256.0 -108.5Q286 -127 330 -127Q383 -127 414.5 -96.5Q446 -66 446 1V80Q421 41 377.0 16.5Q333 -8 274 -8Q205 -8 149.0 27.5Q93 63 60.5 128.5Q28 194 28 280Q28 366 60.5 431.0Q93 496 149.0 531.0Q205 566 274 566Q333 566 377.5 542.0Q422 518 446 479ZM324 417Q273 417 237.5 380.5Q202 344 202 280Q202 216 237.5 178.5Q273 141 324 141Q375 141 410.5 178.0Q446 215 446 279Q446 343 410.5 380.0Q375 417 324 417Z",
    fill: "#0A0A12"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(971.9,192) scale(0.150000,-0.150000)",
    d: "M46 708Q46 748 74.5 774.5Q103 801 148 801Q192 801 220.5 774.5Q249 748 249 708Q249 669 220.5 642.5Q192 616 148 616Q103 616 74.5 642.5Q46 669 46 708ZM233 558V0H62V558Z",
    fill: "#0A0A12"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1016.2,192) scale(0.150000,-0.150000)",
    d: "M617 326V0H447V303Q447 359 418.0 390.0Q389 421 340 421Q291 421 262.0 390.0Q233 359 233 303V0H62V558H233V484Q259 521 303.0 542.5Q347 564 402 564Q500 564 558.5 500.5Q617 437 617 326Z",
    fill: "#0A0A12"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1117.3,192) scale(0.150000,-0.150000)",
    d: "M585 238H198Q202 186 231.5 158.5Q261 131 304 131Q368 131 393 185H575Q561 130 524.5 86.0Q488 42 433.0 17.0Q378 -8 310 -8Q228 -8 164.0 27.0Q100 62 64.0 127.0Q28 192 28 279Q28 366 63.5 431.0Q99 496 163.0 531.0Q227 566 310 566Q391 566 454.0 532.0Q517 498 552.5 435.0Q588 372 588 288Q588 264 585 238ZM413 333Q413 377 383.0 403.0Q353 429 308 429Q265 429 235.5 404.0Q206 379 199 333Z",
    fill: "#0A0A12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotEngineLogoDark);
export default __webpack_public_path__ + "static/media/spot-engine-logo-dark.c0dcc9d414e3e4492428e2eb9cbd9dab.svg";
export { ForwardRef as ReactComponent };